import { marquerRenouveleReconduit } from '@/api/commande/index';
import * as devisConf from '@/configuration/devisConf';
import i18n from '@/i18n';

export async function marquerCommandeRenouveleeReconduite(ids, etatRenouvellement) {
  const params = { ids: ids, etatRenouvellement: etatRenouvellement };
  await marquerRenouveleReconduit(params);
  if (ids.length > 1) {
    return etatRenouvellement === devisConf.ETAT_RENOUVELEE
      ? i18n.t('renouvellementCommande.messages.success.changeEtatRenouveleMultiCommande')
      : i18n.t('renouvellementCommande.messages.success.changeEtatTaciteMultiCommande');
  }
  return etatRenouvellement === devisConf.ETAT_RENOUVELEE
    ? i18n.t('renouvellementCommande.messages.success.changeEtatRenouvele')
    : i18n.t('renouvellementCommande.messages.success.changeEtatTacite');
}

export async function marquerListeCommandeRenouveleeReconduite(commandes, etatRenouvellement) {
  const retour = {
    cmdNotChange: [],
    popUpErrorChangeEtat: false,
    success: false,
    messageHeader: null,
    messageFooter: null,
  };
  const predicateRenouvellement = cmd => {
    return cmd.etatRenouvellement === devisConf.ETAT_ENATTENTE
                  || cmd.etatRenouvellement === devisConf.ETAT_ENCOURS;
  };
  const predicateTacite = cmd => {
    return cmd.reconductible
              && (cmd.etatRenouvellement === devisConf.ETAT_ENATTENTE
                  || cmd.etatRenouvellement === devisConf.ETAT_ENCOURS);
  };

  if (commandes.every((cmd) => {
    return (etatRenouvellement === devisConf.ETAT_RENOUVELEE && predicateRenouvellement(cmd))
        || (etatRenouvellement === devisConf.ETAT_TACITE && predicateTacite(cmd));
  })) {
    await this.marquerCommandeRenouveleeReconduite(
      commandes.map(cmd => { return cmd.id; }), etatRenouvellement,
    );
    retour.success = true;
    return retour;
  }
  if (etatRenouvellement === devisConf.ETAT_RENOUVELEE) {
    retour.codeCmdNotChange = commandes
      .filter(cmd => !predicateRenouvellement(cmd))
      .map(cmd => { return { libelle: cmd.code }; });
    retour.popUpErrorChangeEtat = true;
    retour.messageHeader = i18n.t('renouvellementCommande.messages.error.badEtatForChangeEtatRenouvele');
    retour.messageFooter = i18n.t('renouvellementCommande.messages.error.badEtatForChangeEtatRenouveleDes');
  } else if (etatRenouvellement === devisConf.ETAT_TACITE) {
    retour.codeCmdNotChange = commandes
      .filter(cmd => !predicateTacite(cmd))
      .map(cmd => { return { libelle: cmd.code }; });
    retour.popUpErrorChangeEtat = true;
    retour.messageHeader = i18n.t('renouvellementCommande.messages.error.badEtatForChangeEtatTacite');
    retour.messageFooter = i18n.t('renouvellementCommande.messages.error.badEtatForChangeEtatTaciteDes');
  }
  return retour;
}
